<template>
  <div class="tac">
    <div class="mb-3">
      {{lg('',{
        en: 'Share the great news',
        zh: '已经收藏/交易！现在分享',
      })}}
    </div>
    <div class="a2a_kit a2a_kit_size_32 c d-flex justify-content-center" :data-a2a-title="share_title">
      <a class="a2a_button_twitter mx-2">
        <i class="c cp fab fa-twitter"></i>
        <span class="c d-block small" style="line-height: 18px;">
          Twitter
        </span>
      </a>
      <a class="a2a_button_facebook mx-2">
        <i class="c cp fab fa-facebook"></i>
        <span class="c d-block small" style="line-height: 18px;">
          Facebook
        </span>
      </a>
      <a class="a2a_button_telegram mx-2">
        <i class="c cp fab fa-telegram"></i>
        <span class="c d-block small" style="line-height: 18px;">
          Telegram
        </span>
      </a>
      <a class="a2a_button_copy_link mx-2">
        <i class="c cp fas fa-link"></i>
        <span class="c d-block small" style="line-height: 18px;">
          {{lg('',{
            en: 'Copy URL',
            zh: '复制URL',
          })}}
        </span>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'blockShareLinks',
  components: {},
  props: {
    share_link: {
      default: window.location.href
    },
    share_title: {
      default: 'Welcome to JGNNFT!'
    },
  },
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    run(){
      if(!document.querySelector('#a2a_script')){
        let script = document.createElement('script')
        script.id = 'a2a_script'
        script.src = '/static/src/addtoany.js'
        document.body.appendChild(script)
      }else{
        if(window.a2a) window.a2a.init_all()
      }
    }
  },
  created() {
    
  },
  mounted() {
    this.run()
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>